module.exports = __webpack_public_path__ + "static/media/zoom.bdd46b86.svg";